import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs } from "../utils/index.js"

export default class Footer extends Component {
  constructor(obj) {
    super(obj)

    this.form = qs("form", this.el)
    this.listID = this.form.dataset.id
    this.email = ""

    this.errorMessage = qs(".error-message", this.el)
    this.successMessage = qs(".success-message", this.el)

    this.selectBtn = qs(".select-button", this.el)
    this.popover = qs(".popover", this.el)
  }

  on() {
    this.form.addEventListener("submit", this.onSubmit)
    this.selectBtn.addEventListener("click", this.toggleCurrencyMenu)
  }

  toggleCurrencyMenu = () => {
    this.popover.classList.toggle("active")
  }

  onSubmit = e => {
    e.preventDefault()

    this.email = qs(".input", this.form).value

    // this.submitKlaviyoForm()
    this.showError()
  }

  submitKlaviyoForm = () => {
    const myHeaders = new Headers()
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded")

    const urlencoded = new URLSearchParams()

    urlencoded.append("$fields", "email, $source, ")

    urlencoded.append("g", this.listID)
    urlencoded.append("email", this.email)

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    }

    fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", requestOptions)
      .then(response => response.text())
      .then(result => console.log(result))
      .catch(error => {
        console.log("error", error)
        this.showError()
      })
  }

  showSuccess = () => {
    qs(".input", this.form).style.display = "none"
    this.successMessage.style.display = "block"
  }

  showError = () => {
    qs(".input", this.form).style.display = "none"
    this.errorMessage.style.display = "block"

    setTimeout(() => {
      qs(".input", this.form).style.display = "block"
      this.errorMessage.style.display = "none"
    }, 2000)
  }
}
